gform.addFilter('gform_calculation_result', function (result, formulaField, formId, calcObj) {
	if (formId == '3' && formulaField.field_id == '7') {
		if (result !== 0 && result < 1) {
			result = 1;
		}
	}
	return result;
});
